import EditImageMarginsPopover from './EditImageMarginsPopover';

export default EditImageMarginsPopover;
